import React, { useState, useEffect } from 'react';
import { Navbar } from 'react-bootstrap';
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Container from 'react-bootstrap/Container';
import 'bootstrap/dist/css/bootstrap.min.css';
import './NavigationBar.css';
import UserIcon from './UserIcon';

function NavigationBar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 0;
      setScrolled(isScrolled);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <Navbar
    className={scrolled ? 'navbar scrolled' : 'navbar'}
    variant='dark'
    expand="sm"
    fixed="top"
    >
        <Navbar.Brand href="/">Golden Teacher</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="me-auto">
        </Nav>
        <Nav>
            <Nav.Link href="/">⭐️ ₲ØⱠĐɆ₦ ₮Ɇ₳₵ⱧɆⱤ ⭐️</Nav.Link>
            <Nav.Link eventKey={2} href="gigs">
            Gigs
            </Nav.Link>
            <UserIcon />
        </Nav>
        </Navbar.Collapse>
    </Navbar>
  );
}

export default NavigationBar;
